import { useState, useEffect } from 'react';

export const useScreenSize = () => {
  const [isCompactMode, setIsCompactMode] = useState(false);
  
  useEffect(() => {
    const checkScreenSize = () => {
      // Enable compact mode on screens smaller than 768px (tablet and mobile)
      setIsCompactMode(window.innerWidth < 768);
    };
    
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);
  
  return { isCompactMode };
};